import { supabase } from "@/integrations/supabase/client";

/**
 * Best-effort transactional email send. Never throws — email failures must
 * not block the user-facing flow that triggered them.
 *
 * Language resolution: explicit `lang` arg → `profiles.preferred_language`
 * for the current user → 'es' fallback.
 */
export async function sendLifecycleEmail(opts: {
  baseTemplate: "module-completed" | "program-completed" | "password-changed";
  recipientEmail: string;
  idempotencyKey: string;
  userId?: string;
  lang?: "es" | "en";
  templateData?: Record<string, unknown>;
}) {
  try {
    let lang: "es" | "en" = opts.lang ?? "es";
    if (!opts.lang && opts.userId) {
      try {
        const { data } = await (supabase as any)
          .from("profiles")
          .select("preferred_language")
          .eq("id", opts.userId)
          .maybeSingle();
        const pl = (data as any)?.preferred_language;
        if (pl === "en" || pl === "es") lang = pl;
      } catch {
        /* ignore — fall through to default */
      }
    }
    const templateName = `${opts.baseTemplate}-${lang}`;
    await supabase.functions.invoke("send-transactional-email", {
      body: {
        templateName,
        recipientEmail: opts.recipientEmail,
        idempotencyKey: opts.idempotencyKey,
        templateData: opts.templateData ?? {},
      },
    });
  } catch (e) {
    // Swallow — observability only.
    // eslint-disable-next-line no-console
    console.warn("[lifecycle-email] send failed", opts.baseTemplate, e);
  }
}
